/**
 * Authentication providers configuration
 *
 * Set REACT_APP_AUTH_PROVIDER in your .env to select the provider.
 *
 * Provider mapping:
 * ┌──────────┬─────────────────────────────────────────────────────────────────┐
 * │ Provider │ Usage                                                           │
 * ├──────────┼─────────────────────────────────────────────────────────────────┤
 * │ auth0    │ Sttok, PWC, PLD. Auth0 Hosted UI with tenant-specific domains.   │
 * │          │ Tenant selected via /login, /pwc-login, /pld-login.             │
 * ├──────────┼─────────────────────────────────────────────────────────────────┤
 * │ cognito  │ Initial Cognito implementation. Uses Cognito Hosted UI           │
 * │          │ (react-oidc-context). User logs in on Cognito's login page.      │
 * ├──────────┼─────────────────────────────────────────────────────────────────┤
 * │ custom   │ Cognito integration via OTP. AWS backend sends OTP to email.    │
 * │          │ Used for AXA. May include Myriam SAML as additional option.     │
 * └──────────┴─────────────────────────────────────────────────────────────────┘
 */
export enum AuthProviders {
  AUTH0 = 'auth0', // eslint-disable-line
  COGNITO = 'cognito', // eslint-disable-line
  CUSTOM = 'custom', // eslint-disable-line
}

export const getCurrentAuthProvider = (): AuthProviders => {
  const provider = process.env.REACT_APP_AUTH_PROVIDER?.toLowerCase();

  switch (provider) {
    case 'auth0':
      return AuthProviders.AUTH0;
    case 'cognito':
      return AuthProviders.COGNITO;
    case 'custom':
      return AuthProviders.CUSTOM;
    default:
      return AuthProviders.AUTH0;
  }
};

export const isAuth0Enabled = (): boolean =>
  getCurrentAuthProvider() === AuthProviders.AUTH0;

export const isCognitoAuthEnabled = (): boolean =>
  getCurrentAuthProvider() === AuthProviders.COGNITO;

export const isCustomAuthEnabled = (): boolean =>
  getCurrentAuthProvider() === AuthProviders.CUSTOM;
